import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

//JSON
import en from './translations/en/translation.json';
import es from './translations/es/translation.json';

i18n
  .use(LanguageDetector)       // detecta el idioma del navegador
  .use(initReactI18next)       // conecta con React
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: (code) => {
      // Si el idioma detectado no es inglés ni español, usar inglés
      if (code !== 'en' && code !== 'es') {
        return 'en';
      }
      // De lo contrario, usar español como fallback original
      return 'es';
    },
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: [] ,
    },
    interpolation: {
      escapeValue: false,      // React ya hace el escape
    },
    react: {
      useSuspense: false,      // si no quieres Suspense
    },
  });

export default i18n;
